/** Dependencies */
import CustomerDetails from './CustomerDetails';
import CustomerDetailWizard from './CustomerDetailsWizard';

export { CustomerDetailWizard };

export default CustomerDetails;
